import React, { useState, useCallback, useEffect } from 'react'
import { View, TouchableOpacity, ActivityIndicator } from 'react-native'
import { TextInput } from '../molecules/TextInput'
import { Text, IconName } from '../atoms'
import { EncounterPlace } from '@utils'

// Type for a location result from Nominatim
export type LocationResult = {
  place_id: string
  display_name: string
  address: {
    city?: string
    country?: string
    state?: string
    region?: string
  }
}

interface Props {
  value: string
  onChange: (value: EncounterPlace) => void
  placeholder?: string
  title?: string
  isBigTitle?: boolean
  iconRight?: string
  iconLeft?: string
  testID?: string
}

export const FormLocation = ({ value, onChange, ...props }: Props) => {
  const [query, setQuery] = useState(value || '')
  const [results, setResults] = useState<LocationResult[]>([])
  const [showDropdown, setShowDropdown] = useState(false)
  const [loading, setLoading] = useState(false)
  let debounceTimeout: NodeJS.Timeout

  // Sync local query with parent value (for form reset, etc.)
  useEffect(() => {
    setQuery(value || '')
  }, [value])

  // Debounced search
  const searchLocation = useCallback((text: string) => {
    if (debounceTimeout) clearTimeout(debounceTimeout)
    setQuery(text)
    if (text.length < 3) {
      setResults([])
      setLoading(false)
      return
    }
    setLoading(true)
    debounceTimeout = setTimeout(async () => {
      try {
        const res = await fetch(
          `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(text)}&format=json&addressdetails=1&limit=5`, //non-commercial use only
        )
        const data = await res.json()
        setResults(data)
      } catch (error) {
        setResults([])
        console.error('Search error:', error)
      } finally {
        setLoading(false)
      }
    }, 400)
  }, [])

  return (
    <View>
      <TextInput
        testID={props.testID}
        value={query}
        onChangeText={(text) => {
          setQuery(text)
          searchLocation(text)
          setShowDropdown(true)
        }}
        placeholder={props.placeholder || 'Rechercher un lieu'}
        onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
        title={props.title}
        isBigTitle={props.isBigTitle}
        iconRight={props.iconRight as IconName | undefined}
        iconLeft={props.iconLeft as IconName | undefined}
      />
      {loading && <ActivityIndicator style={{ marginVertical: 8 }} size="small" color="#888" />}
      {showDropdown && results.length > 0 && (
        <View
          style={{
            backgroundColor: 'white',
            //borderWidth: 1,
            //borderColor: '#eee',
          }}
        >
          {results.map((item) => (
            <TouchableOpacity
              key={item.place_id}
              onPress={() => {
                onChange({
                  place: item.display_name,
                  city: item.address.city || '',
                  country: item.address.country || '',
                  state: item.address.state || '',
                  region: item.address.region || '',
                })
                setQuery(item.display_name)
                setShowDropdown(false)
              }}
              style={{
                marginHorizontal: 10,
                paddingVertical: 10,
                borderBottomWidth: 0.5,
                borderBottomColor: 'grey',
              }}
            >
              <Text type="body">{item.display_name}</Text>
            </TouchableOpacity>
          ))}
        </View>
      )}
    </View>
  )
}
